import { NetworkRepWithSource } from "../@types";

const escapeCell = (val: unknown): string => {
  const s = val == null ? "" : String(val);
  const needsQuoting = s.includes(",") || s.includes('"') || s.includes("\n") || s.includes("\r");
  const quoted = needsQuoting ? `"${s.replace(/"/g, '""')}"` : s;
  // Guard against CSV formula injection (Excel interprets =, +, -, @ as formula prefix)
  if (/^[=+\-@\t\r]/.test(quoted)) {
    return `'${quoted}`;
  }
  return quoted;
};

const row = (cells: unknown[]): string => cells.map(escapeCell).join(",");

const useNetworkReferencesExport = (
  filteredData: NetworkRepWithSource[],
  hash: string
) => {
  const exportCSV = () => {
    const headers = [
      "Classification",
      "Value",
      "Type",
      "Sources",
      "Files",
      "Categories",
      "Reputation (malicious/total)",
      "Associated Malware",
      "First Seen",
      "Last Seen",
      "Country"
    ];

    const lines: string[] = [headers.join(",")];

    for (const item of filteredData) {
      const sources = [...new Set(item.extra.map(e => e.source))].join("; ");
      const files = [
        ...new Set(item.extra.map(e => e.filename).filter(Boolean))
      ].join("; ");
      const categories = (item.categories ?? []).join("; ");
      const rep = item.third_party_reputations;
      const reputation =
        rep != null ? `${rep.malicious ?? 0}/${rep.total ?? 0}` : "";

      lines.push(
        row([
          item.classification,
          item.requested_network_location,
          item.type,
          sources,
          files,
          categories,
          reputation,
          item.associated_malware ? "yes" : "no",
          item.first_seen,
          item.last_seen,
          item.country
        ])
      );
    }

    const csv = lines.join("\n");
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `network_references_${hash.slice(0, 8)}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  return { exportCSV };
};

export default useNetworkReferencesExport;
